import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const GlobalDndContext = (props) => <DndProvider backend={HTML5Backend} key={1}>{props.children}</DndProvider>;

export default GlobalDndContext;
